import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
// constants
import { PATH_AUTH } from "./paths";

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  // SaaS shutdown: never render the authenticated app. Always send
  // visitors to the announcement page rendered at /login.
  void children;
  return <Navigate to={PATH_AUTH.login} replace />;
}